import axios, { type AxiosInstance } from 'axios';

export interface AuthClient {
  login(email: string, password: string): Promise<unknown>;
  logout(): Promise<void>;
  refresh(refreshToken: string): Promise<unknown>;
  me(): Promise<unknown>;
  /** Request a password-reset link be emailed (always resolves — no existence leak). */
  requestPasswordReset(email: string): Promise<void>;
  /** Set a new password from a reset-link token. Rejects on invalid/expired tokens. */
  resetPassword(token: string, password: string): Promise<void>;
}

export function createAuthClient(baseUrl: string): AuthClient {
  const http: AxiosInstance = axios.create({ baseURL: baseUrl, withCredentials: true });
  return {
    async login(email, password) {
      const { data } = await http.post('/auth/login', { email, password });
      return data;
    },
    async logout() {
      await http.post('/auth/logout');
    },
    async refresh(refreshToken) {
      const { data } = await http.post('/auth/refresh', { refreshToken });
      return data;
    },
    async me() {
      const { data } = await http.get('/auth/me');
      return data;
    },
    async requestPasswordReset(email) {
      await http.post('/auth/password/forgot', { email });
    },
    async resetPassword(token, password) {
      await http.post('/auth/password/reset', { token, password });
    },
  };
}
